/* eslint-disable no-nested-ternary */
import React, { ReactNode } from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useResponsive } from '../../hooks/useResponsive';

import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from './headerConstants';

export const StyledToolbar = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'teamColor',
})<{ teamColor?: boolean }>(({ theme, teamColor }) => {
  return {
    [theme.breakpoints.up('sm')]: {
      height: HEADER_HEIGHT_DESKTOP,
      minHeight: HEADER_HEIGHT_DESKTOP,
    },
    height: HEADER_HEIGHT_MOBILE,
    minHeight: HEADER_HEIGHT_MOBILE,
    background: teamColor
      ? theme.palette.primary.main
      : theme.palette.mode === 'light'
      ? theme.palette.grey[200]
      : theme.palette.grey[800],
  };
});

export interface HeaderProps {
  onOpenMobileSidebar?: VoidFunction;
  withMobileNavbar?: boolean;
  toolbar: ReactNode;
  logo: ReactNode;
  teamColor?: boolean;
}

export const Header = ({ onOpenMobileSidebar, withMobileNavbar, toolbar, logo, teamColor }: HeaderProps) => {
  const isDesktop = useResponsive('up', 'md');

  const iconMobileSidebar = withMobileNavbar ? (
    <IconButton onClick={onOpenMobileSidebar} data-testid="sidebar-icon">
      <MenuIcon />
    </IconButton>
  ) : (
    logo
  );

  return (
    <AppBar position="fixed" sx={{ boxShadow: 'none', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <StyledToolbar disableGutters teamColor={teamColor}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: { xs: 4, sm: 9 },
          }}
        >
          {isDesktop ? logo : iconMobileSidebar}

          <Stack direction="row" alignItems="center" spacing={{ xs: 2, sm: 5 }}>
            {toolbar}
          </Stack>
        </Box>
      </StyledToolbar>
    </AppBar>
  );
};
